import { FunctionComponent, type PropsWithChildren, type ReactNode } from 'react';

import styles from './InputGroup.module.css';

export interface InputGroupProps extends PropsWithChildren {
  /** Input to be displayed */
  input?: ReactNode;
}

/**
 * # InputGroup
 *
 * A component to group input with other actions
 * */
export const InputGroup: FunctionComponent<InputGroupProps> = ({ children, input }) => {
  return (
    <div className={styles.inputGroup}>
      {input ? <div className={styles.inputGroup__input}>{input}</div> : null}
      {children ? <div className={styles.inputGroup__children}>{children}</div> : null}
    </div>
  );
};
